import React from 'react'
import { Details, Title, Message, DarkBlueBadge, LightBlueBadge } from '../data-card/data-card-parts'
import { Link } from 'react-router'

import { DataCard } from '../data-card/data-card-parts'

export default ({
  pathname,
  workSummary,
  summarizable
}) => (
  <DataCard>
    <Link to={`/${pathname}/${workSummary.id}`}>
      {workSummary.hasImages &&
        <img src={require('../../images/camera_button_black.svg')} alt="Has images" style={{position: 'absolute', right: '10px'}} height="20px" />}
      <Details>
        <p><LightBlueBadge text={workSummary.id} /></p>
        <Title text={workSummary.locationName} />
      </Details>
      <Details>
        <Message text={
          formatStatus(workSummary)
        } />
      </Details>
      {technicianList(workSummary)}
    </Link>
  </DataCard>
)

function formatStatus (workSummary) {
  if (workSummary.updatedAt) {
    return `Starts on ${workSummary.updatedAt.format('MMMM D, YYYY [at] h:mm A')}`
  } else {
    return ''
  }
}

function technicianList (workSummary) {
  return <Message text={`Technicians: ${workSummary.technicianNames.join(', ') || 'None'}`} />
}



// WEBPACK FOOTER //
// ./src/components/work-summaries/work-summary-work-order-card.js